import {
    HELP_ANCHOR_ATTRIBUTE,
    isKnownHelpAnchor,
} from '../config/helpAnchors';

export const isVisibleHelpTarget = (element, windowObject = window) => {
    if (!element?.isConnected) return false;

    const style = windowObject.getComputedStyle(element);
    if (
        style.display === 'none'
        || style.visibility === 'hidden'
        || style.visibility === 'collapse'
    ) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
};

export const findVisibleHelpTarget = ({
    targetCandidates = [],
    root = document,
    windowObject = window,
} = {}) => {
    for (const targetId of targetCandidates) {
        if (!isKnownHelpAnchor(targetId)) continue;

        const element = root.querySelector(`[${HELP_ANCHOR_ATTRIBUTE}="${targetId}"]`);
        if (isVisibleHelpTarget(element, windowObject)) return element;
    }

    return null;
};

export const watchForHelpTarget = ({
    targetCandidates = [],
    root = document,
    windowObject = window,
    timeoutMs = 1500,
    MutationObserverClass = windowObject.MutationObserver,
    isReady = () => true,
} = {}) => {
    let observer = null;
    let timeoutId = null;
    let settled = false;
    let resolvePromise;

    const finish = (target) => {
        if (settled) return;
        settled = true;
        observer?.disconnect();
        if (timeoutId !== null) windowObject.clearTimeout(timeoutId);
        resolvePromise(target);
    };

    const check = () => {
        const target = findVisibleHelpTarget({ targetCandidates, root, windowObject });
        if (target && isReady(target)) finish(target);
    };

    const promise = new Promise((resolve) => {
        resolvePromise = resolve;

        if (targetCandidates.length === 0) {
            finish(null);
            return;
        }

        check();
        if (settled) return;

        if (MutationObserverClass && root.body) {
            observer = new MutationObserverClass(check);
            observer.observe(root.body, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }

        if (timeoutMs !== null) {
            timeoutId = windowObject.setTimeout(() => finish(null), timeoutMs);
        }
    });

    return {
        promise,
        cancel: () => finish(null),
    };
};
